var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 7.5H2.25",
  stroke: "#344DA6",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 4.5H2.25",
  stroke: "#344DA6",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 10.5H2.25",
  stroke: "#344DA6",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 13.5H2.25",
  stroke: "#344DA6",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgAdvisoryIcon = function SvgAdvisoryIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdvisoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Advisory-icon.e859ebca.svg";
export { ForwardRef as ReactComponent };